<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
				<div class="login-wrapper">
					<div class="login-content">
						<div class="login-content__logo">
							<img src="@/assets/img/logo.png" alt=""/>
						</div>
						<router-view name="login"/>
						<div class="login-content__footer">
							<a class="link" target="_blank" href="https://docura.net/">docura.net</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: 'AuthLayout'
}
</script>
